// schemas/userSigninRequestOtpSchema.ts

import { z } from 'zod';
import { OtpChannel } from '@/core/enums/otp-channel.enum';

export const userSigninRequestOtpSchema = z.object({
  otpChannel: z.union([z.literal(OtpChannel.Sms), z.literal(OtpChannel.Email)]),
});

export type UserSigninRequestOtpFormValues = z.infer<typeof userSigninRequestOtpSchema>;
